/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {

  /* ──────────────────────────────────────────────────────────────
     Product-card option swatches (.pgi-opts Material / Colour circles):
     clicking one swaps the card's featured photo AND price to that variant's.
     Works anywhere the product-grid-item snippet renders (collection
     template + featured collection), via a single delegated listener.
     The variant is resolved from the active value in every option group, so
     choosing a Colour keeps the Material picked before (and vice versa).
     Variant data comes from the data-pgi-variants JSON in product-grid-item.liquid.
  ────────────────────────────────────────────────────────────────── */
  function getCardVariants(opts) {
    if (opts._pgiVariants) return opts._pgiVariants;
    var json = opts.querySelector('[data-pgi-variants]');
    try {
      opts._pgiVariants = json ? JSON.parse(json.textContent) : [];
    } catch (e) {
      opts._pgiVariants = [];
    }
    return opts._pgiVariants;
  }

  // Add/replace the ?variant= param on a product URL (keeps other params + hash).
  function setVariantParam(url, id) {
    if (!url) return url;
    var hash = '';
    var hi = url.indexOf('#');
    if (hi >= 0) { hash = url.slice(hi); url = url.slice(0, hi); }
    var parts = url.split('?');
    var params = (parts[1] || '').split('&').filter(function (p) {
      return p && p.indexOf('variant=') !== 0;
    });
    params.push('variant=' + id);
    return parts[0] + '?' + params.join('&') + hash;
  }

  // Best variant for the current selection: must match the clicked option's value,
  // then rank by how many of the other selected values it also matches. When
  // requireImage is true only variants that carry a photo are considered.
  function resolveVariant(variants, selected, clickedIndex, requireImage) {
    var best = null;
    var bestScore = -1;
    variants.forEach(function (v) {
      if (requireImage && !v.image) return;
      if (v.options[clickedIndex] !== selected[clickedIndex]) return;
      var score = 0;
      selected.forEach(function (val, i) {
        if (val != null && v.options[i] === val) score++;
      });
      if (score > bestScore) {
        best = v;
        bestScore = score;
      }
    });
    return best;
  }

  // Set the card price (and strike-through compare-at on sale) to the variant's,
  // keeping the <a> wrapper (href/data attrs) intact — only its content changes.
  // If the card showed a "From {price}" prefix (price varies), keep it: the
  // template lives on .pgi-opts[data-pgi-from] with a %%PRICE%% token.
  function updateCardPrice(card, opts, variant) {
    if (!variant || variant.price == null) return;
    var priceEl = card.querySelector('.product-grid-item__price');
    if (!priceEl) return;
    var priceHtml = variant.compare
      ? '<span class="product-grid-item__price-new">' + variant.price + '</span> <s>' + variant.compare + '</s>'
      : variant.price;
    var fromTpl = opts && opts.getAttribute('data-pgi-from');
    priceEl.innerHTML = fromTpl ? fromTpl.replace('%%PRICE%%', priceHtml) : priceHtml;
  }

  function applyVariantSelection(swatch) {
    var card = swatch.closest('[data-product-block], .product-grid-item');
    var opts = swatch.closest('.pgi-opts');
    if (!card || !opts) return;

    // Reflect the active swatch within its own option group.
    var group = swatch.closest('.pgi-opt__swatches');
    if (group) {
      group.querySelectorAll('[data-pgi-swatch]').forEach(function (s) {
        s.classList.remove('is-active');
      });
    }
    swatch.classList.add('is-active');

    // Collect the active value of every option group (indexed by option position).
    var selected = [];
    opts.querySelectorAll('[data-pgi-swatch].is-active').forEach(function (s) {
      selected[parseInt(s.getAttribute('data-option-index'), 10)] = s.getAttribute('data-value');
    });

    var clickedIndex = parseInt(swatch.getAttribute('data-option-index'), 10);
    var variants = getCardVariants(opts);

    // Price: the exact variant for the selection (image not required).
    var priceVariant = resolveVariant(variants, selected, clickedIndex, false);
    updateCardPrice(card, opts, priceVariant);

    // Quick-buy opens a quick-view preview — make it open on the chosen variant.
    // The theme's quick-view reads data-variant-id off the button (&variant=<id>).
    if (priceVariant && priceVariant.id != null) {
      var qv = card.querySelector('[data-button-quick-view]');
      if (qv) {
        qv.setAttribute('data-variant-id', priceVariant.id);
        var href = qv.getAttribute('href');
        if (href) qv.setAttribute('href', setVariantParam(href, priceVariant.id));
      }
    }

    // Image: the same variant if it has a photo, else the closest one that does.
    var imgVariant = priceVariant && priceVariant.image
      ? priceVariant
      : resolveVariant(variants, selected, clickedIndex, true);
    if (!imgVariant || !imgVariant.image) return;
    var url = imgVariant.image;

    // Target the currently-visible featured image (fall back to the tagged one).
    var figure = card.querySelector('.product__media--featured-visible') ||
                 card.querySelector('[data-product-image]');
    var img = figure ? (figure.tagName === 'IMG' ? figure : figure.querySelector('img')) : null;
    if (!img) return;

    // Point every source at the chosen image so nothing (srcset, a lazy-loader
    // re-reading data-* on prod, etc.) can revert it to the original photo.
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
    img.setAttribute('srcset', url);
    img.setAttribute('src', url);
    img.classList.remove('is-loading');
    img.classList.add('lazyloaded');

    var hoverImg = card.querySelector('.product__media__hover img');
    if (imgVariant.hover && hoverImg) {
      hoverImg.removeAttribute('data-src');
      hoverImg.removeAttribute('data-srcset');
      hoverImg.setAttribute('srcset', imgVariant.hover);
      hoverImg.setAttribute('src', imgVariant.hover);
      hoverImg.classList.remove('is-loading');
      hoverImg.classList.add('lazyloaded');
      card.classList.remove('pgi-photo-locked');
    } else {
      card.classList.add('pgi-photo-locked');
    }
  }

  // Capture phase + stopPropagation: run before any other handler so nothing
  // else can swallow the swatch click (and so clicking a swatch never bubbles
  // up to trigger a card/product-link navigation).
  document.addEventListener('click', function (event) {
    var swatch = event.target.closest && event.target.closest('[data-pgi-swatch]');
    if (!swatch) return;
    event.preventDefault();
    event.stopPropagation();
    applyVariantSelection(swatch);
  }, true);

  // Keyboard support (role="button").
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
    var swatch = event.target.closest && event.target.closest('[data-pgi-swatch]');
    if (!swatch) return;
    event.preventDefault();
    event.stopPropagation();
    applyVariantSelection(swatch);
  }, true);

  /* ──────────────────────────────────────────────────────────────
     Mobile card titles on one line. CSS already forces nowrap + ellipsis
     below 750px; here we shrink the font (down to a 13px floor) so the title
     fits on a single line before the ellipsis ever kicks in. Short titles stay
     at their normal size; only the ones that would overflow get reduced, and
     truly long ones bottom out at 13px and then ellipsize.
  ────────────────────────────────────────────────────────────────── */
  var TITLE_MIN = 13; // px — don't shrink below this; ellipsize instead

  function fitTitle(title) {
    title.style.fontSize = ''; // reset to the CSS value first
    if (window.innerWidth > 749) return; // desktop: leave default (may wrap)
    if (!title.offsetParent) return; // not visible / laid out

    var size = parseFloat(window.getComputedStyle(title).fontSize);
    if (!size) return;
    if (title.scrollWidth <= title.clientWidth + 1) return; // already fits — keep full size

    // Estimate the fitting size in one step (text width scales ~linearly with
    // font size), clamp to the floor, then fine-tune a few steps for accuracy.
    var ratio = title.clientWidth / title.scrollWidth;
    size = Math.max(TITLE_MIN, Math.floor(size * ratio * 10) / 10);
    title.style.fontSize = size + 'px';

    var guard = 10;
    while (title.scrollWidth > title.clientWidth + 1 && size > TITLE_MIN && guard-- > 0) {
      size = Math.max(TITLE_MIN, size - 0.5);
      title.style.fontSize = size + 'px';
    }
  }

  function fitAllTitles() {
    document.querySelectorAll('.product-grid-item__title').forEach(fitTitle);
  }

  var titleTimer;
  function scheduleFitTitles() {
    clearTimeout(titleTimer);
    titleTimer = setTimeout(fitAllTitles, 120);
  }

  fitAllTitles();
  window.addEventListener('resize', scheduleFitTitles);
  // Re-fit once the web font has loaded (metrics change).
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(fitAllTitles);
  }
  // Re-fit when new cards appear (infinite scroll / filtering / section reload).
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          scheduleFitTitles();
          break;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
